import { RouterProvider } from 'react-router-dom';

import { router } from '@app/router';
import ModalForms from '@app/modal-forms';
import { AuthProvider, useAuth } from '@context/auth-context';
import { ToastProvider } from '@context/toast-context';

function SessionLoader() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#64748B',
      }}
    >
      Loading session…
    </div>
  );
}

function AppShell() {
  const { isRestoring } = useAuth();

  if (isRestoring) {
    return <SessionLoader />;
  }

  return (
    <>
      <RouterProvider router={router} />
      <ModalForms />
    </>
  );
}

export function AppProviders() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AppShell />
      </ToastProvider>
    </AuthProvider>
  );
}
